import { render, staticRenderFns } from "./bkv-schema-editor.vue?vue&type=template&id=5c774ede&scoped=true"
import script from "./bkv-schema-editor.vue?vue&type=script&lang=js"
export * from "./bkv-schema-editor.vue?vue&type=script&lang=js"
import style0 from "./bkv-schema-editor.vue?vue&type=style&index=0&id=5c774ede&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c774ede",
  null
  
)

export default component.exports